import { ApplicationUpdateDto, Pagination, PostStatisticsDto, PostStepperDto, PostStepperSaveDto } from '@libs/dto';
import { PaginationQuery } from '@libs/dto';

import { api } from '../common.api';
import { Application, Post } from '@libs/models';

export const adminPostApi = api.injectEndpoints({
  endpoints: (build) => ({
    postStatistics: build.query<PostStatisticsDto, void>({
      query: () => ({
        url: '/post/admin/statistics',
        method: 'GET',
      }),
    }),
    adminPostApplicationsSearch: build.query<Pagination<Application>, PaginationQuery>({
      query: ({ id, q = '', page = 1, limit = 10 } = {}) => ({
        url: `/post/admin/applications/${id}/search`,
        method: 'GET',
        params: { q, page, limit },
      }),
      providesTags: ['Application'],
    }),
    adminUpdateApplication: build.mutation<Application, { id: number; data: ApplicationUpdateDto }>({
      query: ({ id, data }) => ({
        url: `/post/admin/applications/${id}`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['Application'],
    }),
    adminCreatePost: build.mutation<Post, PostStepperDto>({
      query: (dto) => ({
        url: '/post/admin/create',
        method: 'POST',
        body: dto,
      }),
    }),
    adminSavePost: build.mutation<Post, PostStepperSaveDto>({
      query: (dto) => ({
        url: '/post/admin/save',
        method: 'POST',
        body: dto,
      }),
    }),
  }),
});

export const {
  usePostStatisticsQuery,
  useAdminPostApplicationsSearchQuery,
  useAdminUpdateApplicationMutation,
  useAdminCreatePostMutation,
  useAdminSavePostMutation,
} = adminPostApi;
